import { AppBar } from 'react-admin';

export const MomentsAppBar = () => <AppBar />;
